import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const ContentComponent = React.lazy(() => import("../Components/RootComponents/ContentComponent"));
const ContentPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <ContentComponent />
      </Suspense>
    </Fragment>
  );
};

export default ContentPage;
